import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FileInputs, LargeFileInputExample, SmallFileInputExample } from "../../../../Constant";
import CommonFileInput from "./Common/CommonFileInput";
import { FILE_INPUT, FILE_INPUT_LIST } from "../../../../Data/FormControl/BaseInput";

const FileInput = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FileInputs} span={FILE_INPUT} />
        <CardBody>
          {FILE_INPUT_LIST.map((item, index) => (
            <CommonFileInput label={item.label} multiple={item.multiple} disabled={item.disabled} key={index} />
          ))}
          <CommonFileInput label={SmallFileInputExample} size="sm" />
          <CommonFileInput label={LargeFileInputExample} size="lg" />
        </CardBody>
      </Card>
    </Col>
  );
};

export default FileInput;
